import { gql } from '@apollo/client';
import {
  ONCALL_MANAGEMENT_SCHEDULE_FIELDS,
  ONCALL_MANAGEMENT_SCHEDULE_QUERY_FIELDS,
} from './signal-oncall-schedule.fragments';

export const GET_ONCALL_MANAGEMENT_SCHEDULE_QUERY = gql`
  query GetOncallManagementSchedule($params: QueryParams)
  @entity(name: "OncallManagementSchedule") {
    getOncallManagementSchedule(queryParams: $params) {
      records {
        ...OncallManagementScheduleQueryFields
      }
    }
  }
  ${ONCALL_MANAGEMENT_SCHEDULE_QUERY_FIELDS}
`;

export const CREATE_ONCALL_MANAGEMENT_SCHEDULE_MUTATION = gql`
  mutation CreateOncallManagementSchedule($data: OncallManagementScheduleDataInput) {
    createOncallManagementSchedule(data: $data) {
      ...OncallManagementScheduleFields
    }
  }
  ${ONCALL_MANAGEMENT_SCHEDULE_FIELDS}
`;

export const UPDATE_ONCALL_MANAGEMENT_SCHEDULE_MUTATION = gql`
  mutation UpdateOncallManagementSchedule(
    $conditions: [ConditionInput]
    $data: OncallManagementScheduleDataInput
  ) {
    updateOncallManagementSchedule(conditions: $conditions, data: $data) {
      ...OncallManagementScheduleFields
    }
  }
  ${ONCALL_MANAGEMENT_SCHEDULE_FIELDS}
`;
export const DELETE_ONCALL_MANAGEMENT_SCHEDULE_MUTATION = gql`
  mutation DeleteOncallManagementSchedule($conditions: [ConditionInput]) {
    deleteOncallManagementSchedule(conditions: $conditions) {
      id
    }
  }
`;
